import { cloneObject } from '@/shared/clone'
import { deliveryIsFree } from '@/shared/delivery'

export function getCheckoutDeliveryTypes (state) {
  return function (totalCost) {
    if (!state.deliveryTypes && state.deliveryTypes.length === 0) {
      return []
    }

    const deliveryTypes = []

    for (const deliveryType of state.deliveryTypes) {
      const delivery = cloneObject(deliveryType)
      if (deliveryIsFree(delivery, totalCost)) {
        delivery.cost = 0
      }

      deliveryTypes.push(delivery)
    }

    return deliveryTypes
  }
}
